<template>
  <section id="page-car-photo-admin">
    <div class="container">
      <div class="row">

        <clearfix :biggest="true" :bootstrap="true"></clearfix>

        <div class="col-sm-12 content og-bg-dark">
          <h4 class="car-name">{{ car.brand }}</h4> {{ car.model }} ({{ car.year }})
        </div>

        <clearfix :bootstrap="true"></clearfix>

        <div class="col-sm-12 content og-bg-light">
          <clearfix :wide="true"></clearfix>

          <div>
            <form>
              <label for="new-photo">{{ $t('message.form.photo') }}:&nbsp;</label>
              <input id="new-photo" type="file" accept="image/*" @change="onPhotoFileChange">
              &nbsp;
              <b-button :size="'sm'" :variant="'secondary'" @click.prevent="uploadPhoto">
                <icon name="check-circle"></icon>&nbsp;
                {{ $t('message.button.save') }}
              </b-button>
              <div style="display: inline-block">
                <loading-spinner v-show="savingImage"></loading-spinner>
              </div>
            </form>
          </div>

          <clearfix :wide="true"></clearfix>
        </div>

        <clearfix :wide="true" :bootstrap="true"></clearfix>

        <div class="col-sm-12 content og-bg-light" v-show="car.photos.length > 0">
          <gallery :images="preparePhotos(true)" :index="index" @close="index = null"></gallery>
          <div class="gallery-photo" v-for="(photo, photoIndex) in preparePhotos()" :key="photoIndex" @click="index = photoIndex"
               :style="{ backgroundImage: 'url(\'' + $t(imageBase, {car_id: car.id, file_name: photo}) + '\')', width: '300px', height: '200px' }">

            <div class="gallery-photo-control" :title="$t('message.button.delete_photo')"
                 v-on:click="deletePhoto(photo, $event)">x</div>
          </div>
        </div>

        <clearfix :bootstrap="true" v-show="car.photos.length > 0"></clearfix>
      </div>
    </div>
  </section>
</template>

<script>
  import Vue from 'vue'
  import axios from 'axios'
  import VueAxios from 'vue-axios'

  import config from './Config'

  import _ from 'underscore'

  import 'vue-awesome/icons'
  import Icon from 'vue-awesome/components/Icon.vue'
  import miniToastr from 'mini-toastr'
  import VueGallery from 'vue-gallery'

  import LoadingSpinner from '@/components/utils/LoadingSpinner'
  import Clearfix from '../utils/Clearfix'

  Vue.use(VueAxios, axios)

  export default {
    props: {
      carId: String
    },
    data() {
      return {
        car: { photos: [] },
        file: null,
        imageBase: config.urls.image_url,
        index: null,
        savingImage: false
      }
    },
    components: {Clearfix, Icon, 'gallery': VueGallery, LoadingSpinner},
    methods: {
      preparePhotos(merge) {
        return _.map(this.car.photos, (photo) => {
          return merge ? this.$t(config.urls.image_url, {car_id: this.car.id, file_name: photo.fileName}) : photo.fileName
        })
      },
      deletePhoto(fileName, evt) {
        evt.stopPropagation()

        this.savingImage = true
        console.log('File: ' + fileName + ' will be deleted ...')

        Vue.axios.delete(this.$t(config.urls.car_manage_photo, {car_id: this.car.id}) + fileName)
          .then(() => {
            miniToastr.info(this.$t('message.notification.photo_deleted', {file_name: fileName}))
            this.loadCar()
            this.savingImage = false
          })
          .catch(() => {
            miniToastr.error(this.$t('message.notification.photo_not_deleted', {file_name: fileName}))
            this.savingImage = false
          })
      },

      onPhotoFileChange(event) {
        this.file = event.target.files[0]
      },
      uploadPhoto() {
        this.savingImage = true
        const formData = new FormData()
        formData.append('photo', this.file, this.file.name)

        Vue.axios.post(this.$t(config.urls.car_manage_photo, {car_id: this.car.id}), formData)
          .then((response) => {
            miniToastr.info(this.$t('message.notification.photo_uploaded'))
            this.loadCar()
            this.savingImage = false
          })
          .catch(() => {
            miniToastr.error(this.$t('message.notification.photo_upload_failed'))
            this.savingImage = false
          })
      },
      loadCar() {
        Vue.axios.get(config.urls.car + this.carId).then((response) => {
          this.car = response.data
        })
      }
    },
    created() {
      this.loadCar()
    }
  }
</script>

<style>
  #page-car-photo-admin {
    background: url('../../assets/img/bg/bg_renault_engine.jpg') center fixed no-repeat #b1b1b1;
    height: auto;
    margin: 0 auto;
    width: 100%;
    position: relative;
    padding: 30px 0;
  }
</style>



// WEBPACK FOOTER //
// PhotoAdmin.vue?36f3f00e